// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--tJxku","aside":"_93444fe79c--aside--GGHQ9","call":"_93444fe79c--call--jp6Wm"};